<template>
  <v-dialog
    v-model="show"
    :persistent="step > 0"
    max-width="380"
  >
    <v-card light>
      <h-in-out-toolbar
        :amount="floatAmount"
        @close="close()"
      />
      <v-window
        :value="step"
        touchless
      >
        <v-window-item>
          <h-select-mode @select="setMode" />
        </v-window-item>
        <v-window-item>
          <h-calculator
            v-model="textAmount"
            light
          />
        </v-window-item>
        <v-window-item>
          <v-card-text>
            <v-text-field
              v-model="form.reason"
              outlined
              :label="__('inOutReason')"
              persistent-hint
              :hint="__(`cash${mode}`) + ` ${user.name}`"
              @keyup.enter="done()"
            />
          </v-card-text>
        </v-window-item>
      </v-window>
      <v-card-actions v-show="step > 0">
        <v-btn
          text
          color="grey darken-1"
          v-text="__('cancel')"
          @click="close()"
        />
        <v-spacer />
        <v-btn
          v-if="step === 1"
          :disabled="setAmountDisabled"
          text
          color="primary"
          v-text="__('next')"
          @click="setAmount()"
        />
        <v-btn
          v-if="step === 2"
          :disabled="doneDisabled"
          text
          color="primary"
          v-text="__('done')"
          @click="done()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import Userable from '@/Mixins/Userable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import InOutMode from '@/Models/Static/InOutMode'
  import PaymentMethod from '@/Models/Static/PaymentMethod'
  import HInOutToolbar from './Toolbar'
  import HSelectMode from './SelectMode'
  import HCalculator from '@/Components/Calculator'

  export default {
    mixins: [
      Currenciable,
      I18n,
      Userable,
      UsesIcons,
    ],

    components: {
      HInOutToolbar,
      HSelectMode,
      HCalculator,
    },

    data: () => ({
      InOutMode,
      PaymentMethod,
      textAmount: '0',
      form: {
        reason: '',
        amount: 0,
      },
    }),

    computed: {
      ...mapState('cashControl', [
        'turn',
      ]),
      show: {
        get () {
          return this.$store.state.inOut.show
        },
        set (v) {
          if (v) {
            this.$store.dispatch('inOut/open')
          } else {
            this.close()
          }
        },
      },
      step: {
        get () {
          return this.$store.state.inOut.step
        },
        set (v) {
          this.$store.commit('inOut/step', v)
        },
      },
      mode: {
        get () {
          return this.$store.state.inOut.mode
        },
        set (v) {
          this.$store.commit('inOut/mode', v)
        },
      },
      floatAmount () {
        return parseInt(this.textAmount) / 100
      },
      setAmountDisabled () {
        return this.floatAmount.equalTo(0)
      },
      doneDisabled () {
        return this.form.reason.length < 3
      },
    },

    methods: {
      setMode (mode) {
        this.mode = mode
        this.step = 1
      },
      setAmount () {
        this.form.amount = this.mode === InOutMode.IN
          ? this.floatAmount
          : - this.floatAmount
        this.step = 2
      },
      done () {
        this.$log(`Creating ${this.mode} ${this.form.amount}...`, 'Inout')
        this.$api(['save', 'Inout'], {
          id: -1,
          ...this.form,
          tenantUser_id: this.user.id,
          turn_id: this.turn?.id,
          payment_method_id: this.PaymentMethod.CASH,
        })
          .then(r => {
            this.$log(`Created ${this.mode} ${this.form.amount}`, 'Inout', r.data.id)
            this.close()
          })
          .catch(e => this.$store.dispatch('xError', e))
      },
      reset () {
        this.textAmount = '0'
        this.form.reason = ''
        this.form.amount = 0
      },
      close () {
        this.reset()
        this.$store.dispatch('inOut/close')
      },
    },
  }
</script>
